import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from 'material-ui/Button';
import Dialog, { DialogActions, DialogContent, DialogContentText, DialogTitle, } from 'material-ui/Dialog';
import { FormControl } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import Input, { InputLabel } from 'material-ui/Input';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { CircularProgress } from 'material-ui/Progress';
import Slide from 'material-ui/transitions/Slide';

import find from 'lodash/find'

import * as notification from '../../../actions/meetingdetails';
import * as regData from '../../../../appConstants'

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

class Notification extends Component {
    state = {
        notificationtype: 'Not Calendar',
        message: '',
    };

    handleChange(field, e) {
        this.setState({ [field]: e.target.value });
    }
    handleRequestClose = () => {
        this.props.closeDialog();
        // this.setState({ notificationtype: 'Not Calendar', message: '', });
    };

    setData = () => {
        var notificationData = {
            "notificationType":  this.state.notificationtype,
            "meetingId": this.props.id,
            "notificationText": this.state.message
        }
        // console.log(notificationData)
        this.props.actions.sendMeetingNotification(notificationData);
    };

    render() {
        const { id, meetingDetails } = this.props;
        let result = null;
        if (meetingDetails && meetingDetails.Status) {
            result = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }
        let _GrantList = null
        // console.log('Grant id', id)
        if (id) {
            _GrantList = ['Not Calendar', 'Calendar'].map(val => (
                <MenuItem key={val} value={val}
                    style={{ fontWeight: '500' }}>
                    {val}
                </MenuItem>
            ))
        }
        return (
            <div>
                <Dialog open={this.props.open} transition={Slide} onClose={this.handleRequestClose}>
                    <DialogTitle className="bg-primary">
                        <span className="text-white">Meeting Notification</span>
                    </DialogTitle>
                    <DialogContent>
                        {result}
                        <div className="row p-4">
                            <div className="col-md-12">
                                Please enter notification content to be send to the meeting users

                                <ValidatorForm autoComplete="off" ref="notificationform" onSubmit={this.setData.bind(this)}>
                                    <TextValidator margin="normal" className="mt-0 mb-4 col-md-12"
                                        name="message" label="Message" multiline={true}
                                        validators={[regData.regexMultiLineExp,regData.regexMultiLineExpLength]}
                                        errorMessages={[regData.messageMultilineRegexEx, regData.messageMultilineLength]}
                                        value={this.state.message} onChange={this.handleChange.bind(this, 'message')} />
                                    <FormControl className="w-100 mb-2 col-md-12">
                                        <InputLabel htmlFor="age-simple">Select Notification Type</InputLabel>
                                        <Select key="selectType"
                                            value={String(this.state.notificationtype)}
                                            onChange={this.handleChange.bind(this, 'notificationtype')}
                                            input={<Input id="age-simple" />}

                                        >
                                            {_GrantList}
                                        </Select>
                                    </FormControl>
                                </ValidatorForm>
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleRequestClose} variant="raised" className="jr-btn bg-grey text-white">Cancel</Button>
                        <Button onClick={() => this.refs.notificationform.submit()} variant="raised"
                            className="jr-btn bg-primary text-white">Send</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return state
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(notification, dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Notification);


// WEBPACK FOOTER //
// ./app/meetingdetails/meetinglist/notification.js